import { OFFER_PREVIEW_HISTORY_ENTRY } from '../../constants/offerPreview';
import { TThunkAction } from '../../types/redux';
import { backFromModalHistoryEntry, hasModalHistoryEntry } from '../../utils/modalHistory';
import { PREVIEW_OFFERS_REQUEST_KEY } from '../previewOffers/constants';
import { unsetMapOffer } from '../unsetMapOffer/unsetMapOffer';

export function closeOfferPreview(): TThunkAction {
  return (dispatch, _getState, context) => {
    // Превью с записью в history: закрываем шагом назад, закроет «назад» записи (сюда же, уже без записи)
    if (hasModalHistoryEntry(OFFER_PREVIEW_HISTORY_ENTRY)) {
      void backFromModalHistoryEntry(OFFER_PREVIEW_HISTORY_ENTRY);

      return;
    }

    // Ответ на закрытое превью не нужен: отменяем, чтобы он не пришёл в следующее открытие того же пина.
    context.cancellationTokenManager?.cancel(PREVIEW_OFFERS_REQUEST_KEY);
    dispatch(unsetMapOffer());
  };
}
